<template>
  <div>
    <el-dialog
      :visible.sync="open"
      title="Please set the recipient name first"
      width="6.5rem"
      @closed="handleCancel"
    >
      <el-form :model="form" ref="form" label-position="top">
        <el-form-item
          label="You recipient name"
          prop="recipientName"
          :rules="[
            {
              required: true,
              message: 'Please input you recipient name',
              trigger: 'blur',
            },
            {
              pattern: /^[a-zA-Z0-9]{3,30}$/,
              message: 'You need to fill in 3-30 characters, letters and numbers are supported.',
              trigger: 'blur',
            },
          ]"
        >
          <el-input v-model="form.recipientName" autocomplete="off" />
        </el-form-item>
      </el-form>
      <div class="dialog-footer" slot="footer">
        <el-button @click="handleCancel">Cancel</el-button>
        <el-button type="primary" @click="handleSubmite" :loading="btnloading">
          Confirm
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {setRecipientName} from "@/api/message.js"
export default {
  data() {
    return {
      open: false,
      form: {
        recipientName: undefined,
        userID: this.$store.getters.userInfo.userID,
      },
      btnloading: false,
    };
  },
  methods: {
    show() {
      this.open = true;
    },
    handleCancel(){
      this.open = false
      this.$refs['form'].resetFields();
    },
    handleSubmite() {
      this.$refs.form.validate((valide) => {
        if(valide){
          this.btnloading = true;
          setRecipientName(this.form).then(res => {
            this.$message.success('The name is set successfully, you can send the message~')
            this.handleCancel()
            this.$emit('success')
            this.btnloading = false
          }).catch(err => {
            this.btnloading = false
          })
        }
      })
    },
  },
};
</script>

<style lang="scss" scoped>
.table_box {
  overflow: hidden;
}
.des {
  font-size: 0.18rem;
  font-family: Roboto-Bold, Roboto;
  font-weight: bold;
  color: rgba(0, 0, 0, 0.85);
  line-height: 0.28rem;
  margin-bottom: 0.16rem;
}
.total {
  font-size: 0.18rem;
  font-family: Roboto-Regular, Roboto;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.85);
  line-height: 0.28rem;
  margin-top: 0.16rem;
  span {
    color: #000;
  }
}
</style>
